import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import Swal from "sweetalert2";


export default function ExEmailChange({
  email,
  expert_id,
  exObject,
  setExObject,
  backupData,
  setBackupData,
}) {
  const [exEmail, setExEmail] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasSpaces, setHasSpaces] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (email === "None") return;
    setExEmail(email);
  }, [email]);

  const changeEmail = (newValue) => {
    setReturnError(false);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    setLoading(true);
    const url = `${API_URL}change-email`;
    const data = {
      expert_id,
      email: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setExObject({
            ...exObject,
            expertEmail: newValue,
          });
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.email = newValue;
              }
              return item;
            })
          );
        } else if (data.status === "email_exists") {
          Swal.fire({
            title: "Error",
            text: "Given email is associated with another profile. Merge with the other profile.",
            icon: "info",
            showDenyButton: true,
            confirmButtonText: "OK",
            denyButtonText: "Merge",
          }).then(({isConfirmed, isDenied}) => {
            if (isDenied) {
              window.open(`/app/MergeExperts/${expert_id}/${newValue}`, "_self")
            } else if (isConfirmed) {
              Swal.close();
            }
          })
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  useEffect(() => {
    if (exEmail.trim() !== exEmail) {
      setHasSpaces(true);
    } else {
      setHasSpaces(false);
    }
  }, [exEmail]);

  return (
    <>
      <input
        placeholder="Email"
        value={exEmail}
        onChange={(e) => setExEmail(e.target.value)}
        onBlur={(e) => changeEmail(e.target.value)}
        style={{color: hasSpaces ? "red" : "#365561"}}
        onMouseOver={() => hasSpaces && setShowTooltip(true)}
        onMouseOut={() => setShowTooltip(false)}
      />
      {hasSpaces && showTooltip && (
        <div className="absolute bg-gray-200 text-black p-2 rounded shadow-md mt-1" style={{zIndex: "1"}}>
          Remove spaces at the beginning or end.
        </div>
      )}
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
